import { ProductType } from '@frontend/product/types';
import { Navigate, useParams } from 'react-router-dom';

interface ProductCreateRedirectProps {
    type: ProductType.CONSUMABLE | ProductType.EQUIPMENT | ProductType.KIT | ProductType.SERVICE;
}

const ProductCreateRedirect = ({ type }: ProductCreateRedirectProps) => {
    const { accountId } = useParams();
    const path = accountId ? `/accounts/${accountId}/products/create?type=${type}` : `/products/create?type=${type}`;

    return (
        <Navigate
            to={path}
            replace
        />
    );
};

export default ProductCreateRedirect;
